import { render } from "./giveUp.vue?vue&type=template&id=4c3e7776&scoped=true"
import script from "./giveUp.vue?vue&type=script&lang=js"
export * from "./giveUp.vue?vue&type=script&lang=js"

import "./giveUp.vue?vue&type=style&index=0&id=4c3e7776&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3e7776"]])

export default __exports__